import { useQuery } from '@tanstack/react-query';

import type AgentApiCandidateMailTemplatesRecord from '@/types/serializers/AgentApiCandidateMailTemplatesRecord';
import type { AgentApiCandidateMailTemplatesIndex } from '@/types/serializers';

export default function useFetchCandidateMailTemplates() {
  return useQuery<AgentApiCandidateMailTemplatesRecord[]>({
    queryKey: ['candidateMailTemplates'],
    queryFn: async () => {
      const response = await fetch('/agent/api/candidate_mail_templates');
      if (!response.ok) {
        throw new Error('Failed to fetch candidate mail templates');
      }
      const data: AgentApiCandidateMailTemplatesIndex = await response.json();
      return data.records;
    },
  });
}
